import {Component} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UserClubModalComponent} from './user-club-modal/user-club-modal.component';

@Component({
    selector: 'jhi-user-club',
    templateUrl: './user-club.component.html',
    styleUrls: ['./user-club.component.scss'],
})
export class UserClubComponent {
    constructor(private modalService: NgbModal) {
    }

    openJucModal() {
        this.modalService.open(UserClubModalComponent, {size: 'lg'});

    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/user-club/user-club.component.ts